import * as amplitude from "@amplitude/unified";

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || "";

let initPromise: Promise<void> | null = null;

export function initAmplitudeClient(): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.resolve();
  }
  if (!initPromise) {
    initPromise = amplitude.initAll(AMPLITUDE_API_KEY, {
      analytics: { autocapture: true },
      sessionReplay: { sampleRate: 1 }
    });
  }
  return initPromise;
}

export function trackPageView(pathname: string, search: string): void {
  if (typeof window === "undefined") {
    return;
  }
  void initAmplitudeClient().then(() => {
    amplitude.track("page_view", { pathname, search });
  });
}

export function trackEvent(event: string, param?: any): void {
  if (typeof window === "undefined") {
    return;
  }
  void initAmplitudeClient().then(() => {
    amplitude.track(event, param);
  });
}